import { render, staticRenderFns } from "./BadgesView.vue?vue&type=template&id=20b64716&scoped=true&"
import script from "./BadgesView.vue?vue&type=script&lang=js&"
export * from "./BadgesView.vue?vue&type=script&lang=js&"
import style0 from "./BadgesView.vue?vue&type=style&index=0&id=20b64716&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b64716",
  null
  
)

export default component.exports